// English texts of the "vault" area. Keys start with "vault."
export default {
  // Vault panel
  "vault.myMaps": "My Maps",
  "vault.nav.label": "Vault navigation",
  "vault.nav.folders": "Folders",
  "vault.data.import": "Import vault",
  "vault.data.export": "Export vault",
  "vault.category.all": "All maps",
  "vault.category.recent": "Recent",
  "vault.category.recentMaps": "Recent maps",
  "vault.category.shared": "Shared",
  "vault.list.noVault": "Open a vault to see your maps.",
  "vault.list.searchResults": "Search results",
  "vault.list.tagline": "Your maps, together",
  "vault.list.noMatches": "No matches",
  "vault.list.noMatchesHint": "Try another map or folder name.",
  "vault.list.emptyTitle": "A little room for your next idea",
  "vault.list.emptyHint": "Create a map, add a folder, or move a map here.",
  "vault.sort.label": "Sort maps",
  "vault.sort.updated": "Updated",
  "vault.sort.name": "Sort by name",
  "vault.sort.nameAsc": "Sort by name, ascending",
  "vault.sort.nameDesc": "Sort by name, descending",
  "vault.sort.date": "Sort by updated",
  "vault.sort.dateAsc": "Sort by updated, ascending",
  "vault.sort.dateDesc": "Sort by updated, descending",
  "vault.date.justNow": "Just now",
  "vault.date.minutesAgo_other": "{count}m ago",
  "vault.date.hoursAgo_other": "{count}h ago",
  "vault.date.daysAgo_other": "{count}d ago",
  "vault.storage.local": "Local",
  "vault.storage.online": "Online",
  "vault.role.owner": "owner",
  "vault.role.editor": "editor",
  "vault.role.viewer": "viewer",

  // Folders
  "vault.folder.new": "New folder",
  "vault.folder.create": "Create folder",
  "vault.folder.nameLabel": "Folder name",
  "vault.folder.actions": "Folder actions",
  "vault.folder.rename": "Rename folder",
  "vault.folder.move": "Move folder",
  "vault.folder.delete": "Delete folder",
  "vault.folder.deleteConfirm": "Delete “{name}”? All maps and subfolders will be kept in “{parent}”.",
  "vault.folder.vaultRoot": "the vault root",
  "vault.folder.collapse": "Collapse {name}",
  "vault.folder.expand": "Expand {name}",

  // Maps
  "vault.map.new": "New map",
  // Default title of a map created from the vault.
  "vault.map.defaultName": "New map",
  "vault.map.create": "Create map",
  "vault.map.titleLabel": "Map title",
  "vault.map.rename": "Rename map",
  "vault.map.duplicate": "Duplicate map",
  "vault.map.copyTitleLabel": "Copy title",
  "vault.map.copyName": "{title} (copy)",
  "vault.map.localCopyName": "{title} (local copy)",
  "vault.map.duplicated": "Map and attachments duplicated",
  "vault.map.delete": "Delete map",
  "vault.map.deleteConfirm": "Delete “{title}” and its attachments? This cannot be undone.",
  "vault.map.deleteSharedNote": "If shared, recipients will lose access and receive recovery snapshots.",
  "vault.map.deletePermissionsFailed": "Failed to fetch permissions for revocation",
  "vault.map.moved": "Map moved",
  "vault.map.openLabel": "Open {title}",
  "vault.map.attachments": "Attachments",
  "vault.map.attachmentsFor": "Attachments for {title}",
  "vault.map.actions": "Map actions",
  "vault.map.actionsFor": "Actions for {title}",
  "vault.map.move": "Move",
  "vault.map.details": "Details",
  "vault.map.moveOnline": "Move online",
  "vault.map.saveLocally": "Save locally",
  "vault.map.moveToDevice": "Move to this device",
  "vault.map.sharing": "Sharing",
  "vault.map.stopSharing": "Stop sharing",
  "vault.map.leaveShare": "Leave share",
  "vault.map.sharedWithYou": "Shared with you",
  "vault.map.sharedByYou": "Shared by you",
  "vault.details.title": "Map details",
  "vault.details.location": "Location",
  "vault.details.storage": "Storage",
  "vault.details.onDevice": "On this device",
  "vault.details.onlineVault": "Online vault",
  "vault.details.size": "Size",
  // Default title of a map recovered after its share was revoked.
  "vault.recoveredMapName": "Recovered Map",

  // Dialogs
  "vault.dialog.working": "Working…",
  "vault.dialog.failed": "This action could not be completed. Please retry.",
  "vault.dialog.nameRequired": "Enter a name to continue.",
  "vault.dialog.confirmTitle": "Confirm action",
  "vault.move.title": "Move “{name}”",
  "vault.move.submit": "Move here",
  "vault.move.chooseLocal": "Choose a destination in your local vault.",
  "vault.move.chooseOnline": "Choose a destination in your online vault.",
  "vault.move.findFolder": "Find a folder",
  "vault.move.findFolderPlaceholder": "Find a folder…",
  "vault.move.destinations": "Destination folders",
  "vault.move.current": "Current",
  "vault.move.noMatches": "No matching folders",
  "vault.promote.failed": "Could not promote: {error}",
  "vault.promoteError.slots": "Both local and online slots must be loaded (sign in first).",
  "vault.promoteError.notLocal": "Doc is not in the local slot.",
  "vault.promoteError.entryMissing": "Local doc entry not found.",
  "vault.promoteError.writeOnline": "Failed to write online entry: {error}",
  "vault.promoteError.conflict": "Server already owns this docId (409). Promotion aborted.",
  "vault.promoteError.unauthenticated": "Not authenticated (401). Sign in and retry.",
  "vault.promoteError.serverStatus": "Server returned {status} on registration.",
  "vault.promoteError.network": "Network error during registration: {error}",
  "vault.promoteError.upload": "upload to the server failed ({error}); the map stays on this device",
  "vault.saveLocal.confirm": "Save a local copy of \"{title}\"?\n\nA new local-only document will be created from a snapshot of this one. The original online document will not be affected.",
  "vault.saveLocal.failed": "Could not save local copy: {error}",
  "vault.saveLocalError.desktopOnly": "duplicateAsLocal is Tauri-only.",
  "vault.saveLocalError.localNotLoaded": "Local slot not loaded.",
  "vault.saveLocalError.sourceMissing": "Source doc not found.",
  "vault.saveLocalError.sourceNotOnline": "Source doc is not online.",
  "vault.saveLocalError.noLocalFile": "Source doc has no local file yet — open it once to download, then retry.",
  "vault.saveLocalError.readFailed": "Failed to read source file: {error}",
  "vault.saveLocalError.writeFailed": "Failed to write local copy: {error}",
  "vault.saveLocalError.registerFailed": "Failed to register local entry: {error}",
  "vault.error.unexpected": "Unexpected error: {error}",
  "vault.error.unknown": "unknown error",
  "vault.error.unknownShort": "unknown",
  "vault.storageError.onlyOwnMaps": "Only your own maps can be moved.",
  "vault.storageError.openLocal": "Open the local vault first.",
  "vault.storageError.signIn": "Sign in to open the online vault.",
  "vault.storageError.parentGone": "The parent folder is no longer available.",
  "vault.storageError.parentSameVault": "Choose a parent in the same vault.",
  "vault.storageError.localFolders": "Open the local vault before adding local folders.",
  "vault.storageError.rootMove": "The vault root cannot be moved.",
  "vault.storageError.keyMissing": "Your encryption key hasn't reached this device yet. Wait for your vault to sync, then try again.",
  "vault.storageError.destinationGone": "The destination folder is no longer available.",
  "vault.storageError.folderSameVault": "Choose a folder in the same vault.",
  "vault.storageError.localMaps": "Open the local vault before creating local maps.",
  "vault.storageError.createNeedsConnection": "Creating an online map needs the connection. Try again when connected.",
  "vault.storageError.deleteNeedsConnection": "Deleting an online map needs the connection. Nothing was deleted. Try again when connected.",

  // Sharing
  "vault.share.from": "From {name}",
  "vault.share.unknownUser": "Unknown",
  "vault.share.openFailed": "Failed to open share management. Please try again.",
  "vault.unshare.confirm": "Stop sharing \"{title}\"?\n\nAll recipients will lose access to this document.",
  "vault.unshare.failed": "Failed to stop sharing. Please try again.",
  "vault.leave.confirm": "Leave \"{title}\"? You will lose access to this shared content.",
  "vault.leave.failed": "Failed to leave share. Please try again.",
  // Default title of the map created after leaving the open shared map.
  "vault.leave.newMapName": "New Map",

  // Search and picker
  "vault.search.allTitle": "Search all maps",
  "vault.search.folderTitle": "Search current folder",
  "vault.search.noResults": "No results for \"{query}\"",
  "vault.search.noResultsInFolder": "No results for \"{query}\" in this folder",
  "vault.picker.title": "Select a document",
  "vault.picker.filter": "Filter by title...",
  "vault.picker.noMatches": "No matching documents",

  // Attachments
  "vault.attachment.loading": "Loading...",
  "vault.attachment.none": "No attachments",
  "vault.attachment.listFailed": "Failed to load",
  "vault.attachment.openHint": "Click to preview/download",
  "vault.attachment.delete": "Delete attachment",
  "vault.attachment.deleteNamed": "Delete {name}",
  "vault.attachment.deleteConfirm": "Delete this attachment? Links to it in notes will stop working. This cannot be undone.",
  "vault.attachment.deleteFailed": "Failed to delete: {error}",
  "vault.attachment.noKey": "Cannot access attachment: encryption key not available",
  "vault.attachment.loadFailed": "Failed to load attachment: {error}",
  "vault.attachment.saveTitle": "Save attachment",
  "vault.attachment.readyToSave": "Attachment ready to save",
  "vault.attachment.preview": "Preview",
  "vault.attachment.typeUnsupported": "File type .{ext} is not supported.",
  "vault.attachment.tooLarge": "File too large (max {size} MB).",
  "vault.attachment.uploadTitle": "Upload {name}",
  "vault.attachment.uploaded": "Attachment uploaded",
  "vault.attachment.reading": "Reading file…",
  "vault.attachment.encrypting": "Encrypting attachment…",
  "vault.attachment.verifyingKey": "Verifying updated map key…",
  "vault.attachment.uploadConflict": "Upload conflict (409)",
  "vault.attachment.uploadFailed": "Upload failed",
  "vault.attachment.uploadFailedStatus": "Upload failed ({status})",
  "vault.attachment.keyRefreshFailed": "Upload failed: DEK rotated and refresh failed",
  "vault.attachment.downloadTitle": "Download attachment",
  "vault.attachment.ready": "Attachment ready",
  "vault.attachment.connecting": "Connecting for download…",
  "vault.attachment.decrypting": "Decrypting attachment…",
  "vault.attachment.downloadFailedStatus": "Failed to download attachment ({status})",
  "vault.attachment.failures.title": "Attachments not shown",
  "vault.attachment.failures.map": "Map \"{name}\"",
  "vault.attachment.failures.unknownMap": "A map this account cannot open",
  "vault.attachment.failures.file": "\"{name}\"",
  "vault.attachment.failures.unnamed": "Unnamed file",
  "vault.attachment.failures.noKey": "It belongs to a map this account cannot open.",
  "vault.attachment.failures.keyMismatch": "It could not be decrypted: its key does not match its map's key.",
  "vault.attachment.failures.refused": "The server refused it: this map has no such file, or this account has no access to it.",
  "vault.attachment.failures.notFound": "The server does not have it.",
  "vault.attachment.deleteFailedStatus": "Failed to delete attachment ({status})",
  "vault.attachments.loading": "Loading attachments...",
  "vault.attachments.loadFailed": "Failed to load attachments",
  "vault.attachments.summary": "{files} across {documents}",
  "vault.attachments.fileCount_one": "{count} file",
  "vault.attachments.fileCount_other": "{count} files",
  "vault.attachments.documentCount_one": "{count} document",
  "vault.attachments.documentCount_other": "{count} documents",
  "vault.attachments.empty": "No attachments yet. Paste or drop files into any editor to add them.",
  "vault.attachments.deleteAllTitle": "Delete all attachments for this document",
  "vault.attachments.deleteConfirm": "Delete this attachment? This cannot be undone.",
  "vault.attachments.deleteAllConfirm_one": "Delete {count} attachment for \"{title}\"? This cannot be undone.",
  "vault.attachments.deleteAllConfirm_other": "Delete all {count} attachments for \"{title}\"? This cannot be undone.",
  "vault.attachments.deleting": "Deleting...",
  "vault.attachments.deleteSomeFailed": "Failed to delete some attachments: {error}",

  // Sizes and storage
  "vault.size.b": "{size} B",
  "vault.size.kb": "{size} KB",
  "vault.size.mb": "{size} MB",
  "vault.size.gb": "{size} GB",
  "vault.size.unavailableShort": "Unavailable",
  "vault.size.loading": "Loading size…",
  "vault.size.localUnavailable": "Local size unavailable",
  "vault.size.onDevice": "{size} on this device",
  "vault.size.onDeviceTitle": "Stored on this device; excluded from server usage.",
  "vault.size.percentFull": "{percent}% full",
  "vault.size.unavailable": "Size unavailable",
  "vault.size.unavailableTitle": "Server usage could not be read. Retry when connected.",
  "vault.size.detail": "Map: {map} · Attachments: {attachments}",
  "vault.size.attachmentsOnly": "{size} attachments · map size unavailable",
  "vault.size.serverTitle": "Server map snapshots and updates, plus attachment files.",
  "vault.size.sharedTitle": "Shared storage counts toward its owner’s usage.",
  "vault.storage.attachmentTitle": "Attachment storage",
  "vault.storage.vaultTitle": "Vault storage",
  "vault.storage.attachmentNote": "Attachments · map usage unavailable",
  "vault.storage.vaultNote": "Owned maps and attachments · online vault",
  "vault.storage.noteTitle": "Shared maps count toward their owner. Local maps are stored on this device.",
  "vault.storage.pendingRecovery_one": "Includes {size} for {count} map you were removed from, kept so you can recover it.",
  "vault.storage.pendingRecovery_other": "Includes {size} for {count} maps you were removed from, kept so you can recover them.",
  "vault.storage.pendingRecoveryTitle": "Recovering moves the copy into your vault, where you can keep or delete it. Unrecovered copies are deleted a year after the removal.",
  "vault.storage.over": "Storage quota exceeded. Free space to edit or create online maps. Existing data is retained.",
  "vault.storage.near": "More than 90% of your storage quota is used. Free space soon to keep editing.",
  "vault.storage.serverUnavailable": "Server usage unavailable",
  "vault.quota.usage": "{used} / {quota} ({percent}%)",
  "vault.quota.reachedTitle": "Storage quota reached",
  "vault.quota.nearTitle": "Storage almost full",
  "vault.quota.sharedOver": "The map owner’s storage quota has been reached. This map is available to view and export. Editing resumes when the owner frees space or increases their quota.",
  "vault.quota.over": "Your storage quota has been reached. Online maps are available to view and export. Free space or increase your quota to resume editing and creating maps.",
  "vault.quota.near": "You are using more than 95% of your storage quota. Maps and attachments share this space. Free some space soon to keep editing and creating maps.",
  "vault.quota.retained": "Existing data and unsynced edits are retained. You can export backups and remove maps or attachments from the vault.",
  "vault.quota.openVault": "Open vault",
  "vault.quota.editBlocked": "Storage quota reached. Free space in the vault to resume editing.",
  "vault.quota.createBlocked": "Storage quota reached. Free space in the vault before creating an online map.",

  // Progress cards
  "vault.progress.region": "File activity",
  "vault.progress.dismiss": "Dismiss",
  "vault.progress.cancelling": "Cancelling…",
  "vault.progress.processing": "Processing…",
  "vault.progress.ratio": "{current} / {total} · {percent}%",
  "vault.progress.received": "{size} received",
  "vault.progress.keepOpen": "Please keep this tab open.",
  "vault.progress.complete": "Complete",
  "vault.progress.reviewWarnings": "Review the warnings before relying on this result.",
  "vault.progress.failed": "Could not complete",
  "vault.progress.retry": "Please retry.",
  "vault.progress.cancelled": "Cancelled",
  "vault.progress.nothingChanged": "Nothing was changed.",
  "vault.transfer.uploading": "Uploading…",
  "vault.transfer.waitingServer": "Waiting for the server to save…",
  "vault.transfer.downloading": "Downloading…",
  "vault.transfer.connectionFailed": "Upload connection failed",
  "vault.transfer.connectionFailedRetry": "Upload connection failed. Check the connection and retry.",
  "vault.transfer.cancelled": "Upload cancelled",
  "vault.transfer.interrupted": "Upload interrupted",
  "vault.transfer.tooLarge": "Download exceeds its size limit",
  "vault.save.handing": "Handing file to browser…",
  "vault.save.browserManages": "Your browser manages the final save.",
  "vault.save.saving": "Saving to Downloads…",
  "vault.save.savedTo": "Saved to {path}",
  "vault.save.failed": "Save failed: {error}",

  // Export
  "vault.exportOptions.intro": "Choose what to download.",
  "vault.exportOptions.mapOnly": "Map only",
  "vault.exportOptions.mapOnlyHint": "The selected format, without separate attachment files.",
  "vault.exportOptions.withAttachments": "Map + attachments",
  "vault.exportOptions.withAttachmentsHint": "A ZIP containing the map export and its attached files.",
  "vault.exportOptions.privacy": "Exports contain readable data. Keep them somewhere private.",
  "vault.export.failed": "Export failed: {error}",
  "vault.export.failedRetry": "Export failed. Please try again.",
  "vault.export.failedConnection": "Export failed. Check your connection and try again.",
  "vault.export.projectFailed": "Failed to export project.",
  "vault.export.markdownFailed": "Failed to export markdown.",
  "vault.export.svgUnavailable": "SVG export is only available for Mindmap and Gantt views.",
  "vault.export.noMindmap": "No mindmap found to export.",
  "vault.export.noGantt": "No Gantt chart found to export.",
  "vault.export.noData": "No data to export.",
  "vault.export.prepareTitle": "Prepare vault export",
  "vault.export.prepared": "Map data prepared",
  "vault.export.mapUnavailable": "A requested map is unavailable in the vault",
  "vault.export.collecting": "Collecting map data…",
  "vault.export.downloading": "Downloading map data…",
  "vault.export.merging": "Decrypting and merging map data…",
  // Name of a map shared with you, in a vault backup file.
  "vault.export.sharedName": "[shared] {title}",
  "vault.export.mapTitle": "Export map",
  "vault.export.preparingDownload": "Preparing download…",
  "vault.export.collectingAttachments": "Collecting attachments…",
  "vault.export.downloaded": "Export downloaded",
  "vault.export.downloadedWithWarnings": "Export downloaded with warnings",
  "vault.export.ready": "Export ready",
  "vault.export.readyWithWarnings": "Export ready with warnings",
  "vault.export.warn.indexName": "Vault index",
  "vault.export.warn.syncIncomplete": "Vault synchronization is incomplete. This export may be missing maps or folders; preserve the original vault and retry sync.",
  "vault.export.warn.notesName": "Readable notes",
  "vault.export.warn.notesFailed": "Readable note text could not be generated; full CRDT note content is retained.",
  "vault.export.warn.serverUnverified": "Server data could not be verified: {error}. Local data is retained in this export when available.",
  "vault.export.warn.attachmentsExcluded_one": "{count} attachment is not included. Choose Map + attachments for a backup with files.",
  "vault.export.warn.attachmentsExcluded_other": "{count} attachments are not included. Choose Map + attachments for a backup with files.",
  "vault.export.warn.attachmentsUnchecked": "Attachments could not be checked. Download and verify them separately before retiring the source vault.",
  "vault.export.warn.noState": "No readable document state was found. Keep the source vault.",
  "vault.export.warn.incomplete": "Export incomplete: {error}",
  "vault.export.warn.cycle": "Readable tree contains a cycle; full CRDT data is retained for repair.",
  "vault.export.warn.liveUnreadable": "Live document data could not be read: {error}",
  "vault.export.warn.indexedDbUnreadable": "IndexedDB could not be read: {error}. Keep the original vault.",
  "vault.export.warn.nativeFailed": "Native {command} failed: {error}. Keep the original vault.",
  "vault.warnings.title": "Review your backup",
  "vault.warnings.intro": "The file contains the data that could be read. Resolve these items and verify a restore before deleting any source data.",
  "vault.mdExport.date": "Date:",
  "vault.mdExport.author": "Author:",

  // Import
  "vault.import.chooseBackup": "Choose a vault backup in JSON or ZIP format.",
  "vault.import.maps": "Import maps",
  "vault.import.question": "Import {maps} and {folders}?",
  "vault.import.mapCount_one": "{count} map",
  "vault.import.mapCount_other": "{count} maps",
  "vault.import.folderCount_one": "{count} folder",
  "vault.import.folderCount_other": "{count} folders",
  "vault.import.keepExisting": "Existing maps with the same ID will be kept. New maps are added alongside them.",
  "vault.import.importedCount_one": "{count} map imported",
  "vault.import.importedCount_other": "{count} maps imported",
  "vault.import.skippedCount_other": "{count} already present",
  "vault.import.failed": "Import failed: {error}",
  "vault.import.done": "Maps imported",
  "vault.import.finishedWithWarnings": "Import finished with warnings",
  "vault.import.serverSyncFailed": "Server sync failed: {status} - {details}",
  "vault.import.networkError": "Network error: {error}",
  "vault.import.recoveryNotSynced": "Recovery copy has not synced. The original recovery data is retained.",
  "vault.import.invalidFormat": "Invalid export data format",
  "vault.import.unsupportedVersion": "Export format version {version} is not supported",
  "vault.import.invalidDocuments": "Invalid export data: 'documents' must be an array",
  "vault.import.invalidEntry": "Invalid document entry at index {index}: missing id or name",
  "vault.import.duplicateIds": "Duplicate document IDs in backup",
  "vault.import.invalidFolders": "Invalid backup folders",
  "vault.import.cyclicFolders": "Cyclic folder hierarchy in backup",
  "vault.import.sourceWarning": "Source export: {warning}",
  "vault.import.folderFailed": "Folder {name}: {error}. The backup is retained; retry after opening that vault.",
  "vault.import.creating": "Creating maps…",
  "vault.import.noRoot": "Backup CRDT has no readable root; original backup retained",
  "vault.import.noContent": "Backup has no readable document content; keep the original vault",
  "vault.import.restoring": "Restoring map content…",
  "vault.import.relinking": "Relinking and encrypting restored map…",
  "vault.import.restoreIncomplete": "{name}: restore incomplete ({error}); keep the original backup",
  "vault.import.readTitle": "Read import file",
  "vault.import.fileChecked": "Import file checked",
  "vault.import.presentationArchive": "This archive contains a presentation export. Import a JSON or Markdown map export.",
  "vault.import.jsonTooLarge": "JSON file exceeds 50 MB",
  "vault.import.reading": "Reading and checking map data…",
  "vault.import.vaultUnsupported": "Vault export import is not yet supported in this context.",
  "vault.import.invalidProject": "Invalid project file format",
  // Default title of a map imported from a JSON file without a name.
  "vault.import.defaultMapName": "Imported Map",
  "vault.import.mapNamePrompt": "Map name:",
  "vault.import.mapTitle": "Import map",
  "vault.import.restoringMap": "Restoring map…",
  "vault.import.needVault": "Open a vault before importing attachments.",
  "vault.import.projectImported": "Project imported successfully!",
  "vault.import.tooManyHeadings": "Too many headings (>{max}). File may be too large.",
  "vault.import.markdownTooLarge": "File too large. Maximum import size is 10MB.",
  "vault.import.markdownTitle": "Import Markdown",
  "vault.import.readingMarkdown": "Reading Markdown…",
  "vault.import.readFailed": "Could not read the file",
  "vault.import.readInterrupted": "File read interrupted",
  "vault.import.processingMarkdown": "Processing Markdown…",
  "vault.import.noHeadings": "No headings found in the markdown file.",
  "vault.import.noVault": "Cannot import: vault not available.",
  // Default title of a map imported from a Markdown file without a name.
  "vault.import.defaultMarkdownName": "Imported Markdown",
  "vault.import.cancelled": "Import cancelled",
  "vault.import.markdownDone": "Markdown imported",
  "vault.import.markdownFailed": "Failed to import markdown file.",
  "vault.importBrowser.title": "Import from Vault Backup",
  "vault.importBrowser.subtitle": "{documents}, {folders}",
  "vault.importBrowser.documentCount_one": "{count} document",
  "vault.importBrowser.documentCount_other": "{count} documents",
  "vault.importBrowser.folderCount_one": "{count} folder",
  "vault.importBrowser.folderCount_other": "{count} folders",
  "vault.importBrowser.search": "Search documents...",
  "vault.importBrowser.clearSearch": "Clear search",
  "vault.importBrowser.documents": "Documents",
  "vault.importBrowser.allDocuments": "All Documents",
  "vault.importBrowser.unfiled": "Unfiled",
  "vault.importBrowser.sharedTag": "shared",
  "vault.importBrowser.from": "from {name}",
  "vault.importBrowser.noMatches": "No documents matching search",
  "vault.importBrowser.emptyFolder": "No documents in this folder",
  "vault.importBrowser.selectHint": "Click documents to add them to the import list",
  "vault.importBrowser.selected": "Selected ({n})",
  "vault.importBrowser.clearAll": "Clear all",
  "vault.importBrowser.importCount_one": "Import {count} document",
  "vault.importBrowser.importCount_other": "Import {count} documents",

  // Copies, archives and attachment restore
  "vault.copy.unavailable": "This map is no longer available.",
  "vault.copy.unverified": "The complete map could not be verified. Retry when sync is up to date. The original is retained.",
  "vault.copy.noContent": "The full map content is unavailable. Retry after syncing.",
  "vault.copy.attachmentsFailed": "Some attachments could not be copied. Retry when connected. The original is retained.",
  "vault.copy.withWarnings": "Copy retained with warnings",
  "vault.copy.done": "Map duplicated",
  "vault.archive.finding": "Finding attached files…",
  "vault.archive.fileOf": "{label} File {current} of {total}",
  "vault.archive.checking": "Checking attachment…",
  "vault.archive.preparing": "Preparing archive…",
  "vault.archive.building": "Building ZIP…",
  "vault.archive.reading": "Reading ZIP…",
  "vault.archive.checkingIntegrity": "Checking map integrity…",
  "vault.archive.unpacking": "Unpacking and checking files…",
  "vault.archive.mapTooLarge": "Map export exceeds 50 MB. Export smaller groups.",
  "vault.archive.listUnavailable": "Attachment list unavailable: {error}",
  "vault.archive.sizeLimitReached": "Archive size limit reached; export smaller groups.",
  "vault.archive.attachmentTooLarge": "Attachment exceeds the archive size limit; export it separately.",
  "vault.archive.attachmentMissing": "Attachment missing from export: {error}",
  "vault.archive.tooManyFiles": "Archive contains too many files. Export smaller groups.",
  "vault.archive.exportTooLarge": "Archive exceeds 256 MB. Export smaller groups.",
  "vault.archive.importTooLarge": "Archive exceeds 256 MB. Import smaller groups.",
  "vault.archive.fileMissing": "Archive file is missing",
  "vault.archive.expands": "Archive expands beyond its size limit",
  "vault.archive.tooManyEntries": "Too many files in archive",
  "vault.archive.unsafePath": "Unsafe path in archive",
  "vault.archive.unsupported": "Unsupported map archive",
  "vault.archive.mapIntegrity": "Map file integrity check failed",
  "vault.archive.invalidManifest": "Invalid attachment manifest",
  "vault.archive.attachmentIntegrity": "Attachment integrity check failed",
  "vault.restore.title": "Restore attachments",
  "vault.restore.done": "Attachments restored",
  "vault.restore.needsAttention": "Attachment restore needs attention",
  "vault.restore.preparing": "Preparing attachment restore…",
  "vault.restore.failed": "Attachments could not be restored: {error}. Keep the ZIP and retry.",
  "vault.restore.fileFailed": "{name}: attachment restore failed ({error}). Keep the ZIP and original reference.",
  // Title of the document note listing restored files no note links to.
  "vault.restore.noteTitle": "Imported attachments",

  // Attachments kept on this device (engine/services/device-storage.js)
  "vault.device.mapFull": "This map has reached its {limit} limit on this device (content and attachments together).",
  "vault.device.storageLow": "Not enough room left in this browser's storage. Free some space, or move the map online.",
  "vault.device.saving": "Saving on this device…",
  "vault.device.fileMissing": "This attachment is not on this device.",
  "vault.device.needsConnection": "Needs a connection",
  "vault.device.needsConnectionHint": "This file is on the server and has no copy on this device yet. It will show when the connection returns.",
  "vault.device.mayBeCleared": "This browser may delete data stored by Orbital (for example Safari after 7 days without a visit). Keep maps online, or use the desktop app, to be safe.",
  "vault.device.waitingKept": "Kept on this device: it will be sent when the connection returns.",
  "vault.device.waitingSent_one": "{count} file attached while offline was sent.",
  "vault.device.waitingSent_other": "{count} files attached while offline were sent.",
  "vault.device.waitingRefused_one": "{count} file attached while offline could not be sent ({reason}). It stays on this device.",
  "vault.device.waitingRefused_other": "{count} files attached while offline could not be sent ({reason}). They stay on this device.",
  // engine/sync/vault-repair.js: maps missing from the vault, put back automatically
  "vault.repair.restored_one": "A map was missing from your vault and has been put back: {titles}.",
  "vault.repair.restored_other": "{count} maps were missing from your vault and have been put back: {titles}.",
};
